"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PatientIntakeForm = require("./PatientIntakeForm");
Object.keys(_PatientIntakeForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PatientIntakeForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PatientIntakeForm[key];
    }
  });
});